import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import { useApi } from "@core-ui/hooks/useApi";
import useIsOffline from "@ext/errorHandlers/hooks/useIsOffline";
import BranchUpdaterService from "@ext/git/actions/Branch/BranchUpdaterService/logic/BranchUpdaterService";
import OnBranchUpdateCaller from "@ext/git/actions/Branch/BranchUpdaterService/model/OnBranchUpdateCaller";
import MergeRequestTab from "@ext/git/core/GitMergeRequest/components/MergeRequestTab";
import { MERGE_REQUEST_PANEL_ID } from "@ext/git/core/GitMergeRequest/constants";
import { useMergeRequestStore } from "@ext/git/core/GitMergeRequest/logic/store/MergeRequestStore";
import t from "@ext/localization/locale/translate";
import {
	FloatingPanel,
	PanelEmptyState,
	PanelEmptyStateDescription,
	PanelEmptyStateIcon,
	PanelEmptyStateTitle,
} from "@ui-kit/FloatingPanel";
import { ComponentVariantProvider } from "@ui-kit/Providers";
import { MergeRequestPanelMenu } from "./MergeRequestPanelMenu";
import { useMergeRequestPanelAvailability } from "./useMergeRequestPanelAvailability";
import { useRestoreArticleViewOnPanelClose } from "./useRestoreArticleViewOnPanelClose";

export const MergeRequestPanel = () => {
	const isOffline = useIsOffline();
	// MergeRequestStateSync keeps the store current; the panel only shows it.
	const { mergeRequest, isDraft } = useMergeRequestStore((state) => ({
		mergeRequest: state.mergeRequest,
		isDraft: state.isDraft,
	}));
	useMergeRequestPanelAvailability(!!mergeRequest);
	useRestoreArticleViewOnPanelClose();
	const apiUrlCreator = ApiUrlCreatorService.value;
	const { call: deleteMergeRequest } = useApi({
		url: (api) => api.deleteMergeRequest(),
		onDone: () => BranchUpdaterService.updateBranch(apiUrlCreator, OnBranchUpdateCaller.MergeRequest),
	});

	return (
		<FloatingPanel
			headerActions={
				mergeRequest && (
					<ComponentVariantProvider variant="glass">
						<MergeRequestPanelMenu onDelete={() => void deleteMergeRequest()} />
					</ComponentVariantProvider>
				)
			}
			icon="git-pull-request-arrow"
			id={MERGE_REQUEST_PANEL_ID}
			interactionDisabled={isOffline}
			title={t("git.merge-requests.name")}
		>
			<ComponentVariantProvider variant="glass">
				<div className="flex min-h-0 flex-1 flex-col">
					{mergeRequest ? (
						<MergeRequestTab isDraft={isDraft} mergeRequest={mergeRequest} />
					) : (
						<PanelEmptyState>
							<PanelEmptyStateIcon icon="git-pull-request" />
							<PanelEmptyStateTitle>{t("git.merge-requests.empty-state.title")}</PanelEmptyStateTitle>
							<PanelEmptyStateDescription className="max-w-64">
								{t("git.merge-requests.empty-state.description")}
							</PanelEmptyStateDescription>
						</PanelEmptyState>
					)}
				</div>
			</ComponentVariantProvider>
		</FloatingPanel>
	);
};
